import {
  createResource,
  postResource,
} from '@resource/resource'
import { prefixAPI } from '@resource/api'

const MODEL_PREFIX = 'wishlists'

export const LIKE_TOGGLE = prefixAPI('/toggle/{pk}/', MODEL_PREFIX)
export const LIKE_COUNT = prefixAPI('/count/', MODEL_PREFIX)

export const likeToggleResource = createResource(LIKE_TOGGLE, postResource)
export const wishlistCountResource = createResource(LIKE_COUNT)
